/**
 * !!! Такие вещи экспортируем отдельно
 */

export const MANAGERS_ROLES = [ 'area_manager' ]

export const TOP_MANAGERS_ROLES = ['top_manager']

/*** */

export default ['supervisor', 'logistician', ...MANAGERS_ROLES, ...TOP_MANAGERS_ROLES]